/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Invoice } from '../models/Invoice';
import type { OpenCustomInvoiceBody } from '../models/OpenCustomInvoiceBody';
import type { Totals } from '../models/Totals';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InvoicesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns Invoice The Invoice
   * @throws ApiError
   */
  public openCustomInvoice({
    policyId,
    requestBody,
  }: {
    policyId: string,
    /**
     * The Invoice Details
     */
    requestBody: OpenCustomInvoiceBody,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/core/policies/{policyId}/invoices',
      path: {
        'policyId': policyId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Totals The Invoice
   * @throws ApiError
   */
  public policyTotals({
    policyId,
  }: {
    policyId: string,
  }): CancelablePromise<Totals> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/policies/{policyId}/totals',
      path: {
        'policyId': policyId,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public searchInvoices({
    status,
    sortKey,
    sortDirection,
    after,
    limit,
    term,
  }: {
    status?: string,
    sortKey?: string,
    sortDirection?: string,
    after?: string,
    limit?: number,
    term?: string,
  }): CancelablePromise<{
    /**
     * The invoices that matched the criteria
     */
    items: Array<Invoice>;
    /**
     * The cursor to return the next set of invoices
     */
    next: string | null;
    /**
     * The total number of invoices matching the criteria
     */
    total: number;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/invoices',
      query: {
        'status': status,
        'sortKey': sortKey,
        'sortDirection': sortDirection,
        'after': after,
        'limit': limit,
        'term': term,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Invoice The Invoice
   * @throws ApiError
   */
  public findInvoice({
    id,
  }: {
    id: string,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/invoices/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Invoice The Invoices
   * @throws ApiError
   */
  public policyInvoices({
    policyId,
  }: {
    policyId: string,
  }): CancelablePromise<Array<Invoice>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{policyId}/invoices',
      path: {
        'policyId': policyId,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

}
